import { useState, useEffect } from 'react';
import { is_touch_device } from './index';

var toXPorciento = function toXPorciento(val, rect) {
  return 100 * (val - rect.left) / rect.width;
};

var toYPorciento = function toYPorciento(val, rect) {
  return 100 * (val - rect.top) / rect.height;
};

var isTouchDevice = is_touch_device();
var moveEvent = isTouchDevice ? 'touchmove' : 'mousemove';
var downEvent = isTouchDevice ? 'touchstart' : 'mousedown';
var upEvent = isTouchDevice ? 'touchend' : 'mouseup';

var useArrastrable = function useArrastrable(_ref) {
  var elementRef = _ref.elementRef,
      tirador = _ref.tirador,
      onStart = _ref.onStart,
      onArrastrando = _ref.onArrastrando,
      onStop = _ref.onStop;

  var _useState = useState(false),
      preparadoParaArrastrar = _useState[0],
      setPreparadoParaArrastrar = _useState[1];

  var _useState2 = useState(false),
      arrastrando = _useState2[0],
      setArrastrando = _useState2[1];

  var _useState3 = useState({
    x: 0,
    y: 0
  }),
      ancla = _useState3[0],
      setAncla = _useState3[1]; // start


  useEffect(function () {
    if (preparadoParaArrastrar) {
      return;
    } // window.console.log('use-arrastrable', {preparadoParaArrastrar, tirador, elementRef})


    function handleDown(e) {
      e.stopPropagation();
      var rect = elementRef.current.getBoundingClientRect();

      var _ref2 = e.touches ? e.touches[0] : e,
          clientX = _ref2.clientX,
          clientY = _ref2.clientY;

      var ancla = {
        x: clientX - rect.left,
        y: clientY - rect.top
      };
      setAncla(ancla);
      setPreparadoParaArrastrar(true);
    }

    var elemento = tirador ? elementRef.current.querySelector(tirador) : elementRef.current;
    elemento.addEventListener(downEvent, handleDown);
    return function () {
      elemento.removeEventListener(downEvent, handleDown);
    };
  }, [preparadoParaArrastrar, tirador, elementRef]); //
  // dragging
  //

  useEffect(function () {
    if (!preparadoParaArrastrar && !arrastrando) {
      return;
    }

    function handleMove(e) {
      e.preventDefault();
      e.stopPropagation();
      var parentRect = elementRef.current.parentNode.getBoundingClientRect();

      var _ref3 = e.changedTouches ? e.changedTouches[0] : e,
          clientX = _ref3.clientX,
          clientY = _ref3.clientY;

      var position = {
        x: toXPorciento(clientX - ancla.x, parentRect),
        y: toYPorciento(clientY - ancla.y, parentRect)
      };

      if (!arrastrando) {
        setPreparadoParaArrastrar(false);
        setArrastrando(true);
        onStart && onStart(position);
      }

      onArrastrando && onArrastrando(position); // setPosition(position)        
    }

    window.addEventListener(moveEvent, handleMove);
    return function () {
      window.removeEventListener(moveEvent, handleMove);
    };
  }, [preparadoParaArrastrar, elementRef, ancla, arrastrando, onStart, onArrastrando]); //
  // stop dragging
  //

  useEffect(function () {
    function handleUp(e) {
      e.preventDefault();
      setPreparadoParaArrastrar(false);

      if (arrastrando) {
        var rect = elementRef.current.getBoundingClientRect();
        var parentRect = elementRef.current.parentNode.getBoundingClientRect();
        var position = {
          x: toXPorciento(rect.left, parentRect),
          y: toYPorciento(rect.top, parentRect)
        };
        setArrastrando(false);
        onStop && onStop(position);
      }
    }

    window.addEventListener(upEvent, handleUp);
    return function () {
      window.removeEventListener(upEvent, handleUp);
    };
  }, [arrastrando, elementRef, onStop]);
  return {
    arrastrando: arrastrando
  };
};

export default useArrastrable;